module.exports = __webpack_public_path__ + "img/p29176.f3493689.jpg";